import React, { useState, useEffect } from "react";
import "./privacyPolicy.css";
import axios from "axios";
import { ConfigBaseUrl } from "../../../../config";
import { VehicleCode } from "../../../../config";
import ComponentLoader from "../../../../components/componentLoader";

const Privacy = ({ setPrivacy }) => {
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(
        ConfigBaseUrl() +
          `/page-content?PageType=privacy&VehicleCode=${VehicleCode}`
      )
      .then((res) => {
        setData(res.data.Content);
        setIsLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
        setPrivacy(false);
      });
  }, []);

  return (
    <>
      {isLoading ? (
        <ComponentLoader color={"#FFE100"} />
      ) : (
        <div className="privacy_container">
          <div dangerouslySetInnerHTML={{ __html: data }} />
          <div className="button_container">
            <button className="close_btn" onClick={() => setPrivacy(false)}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Privacy;
